import { ValueWithRandom } from "../../ValueWithRandom";
export class SplitFactor extends ValueWithRandom {
    constructor() {
        super();
        this.value = 3;
    }
}
